import {useEffect} from 'react';

import {
  CourseField,
  EmissionDateField,
  EventDaysField,
  HideConclusionDateCheckboxField,
  IncludeEmentaCheckboxField,
  IsEnglishCheckboxField,
  RegenerateCheckboxField,
  SubmitActionsField,
  UserField,
  SpecialistLeanSixSigmaCourseFields,
  TrainingField,
  ManualCourseNameField,
  TrainingDaysField,
  GenerateEspecialistCheckboxField,
  NeedSendEmailCheckboxField,
  WorkloadField,
  ManualEmentaField,
  IncludeCourseSignaturesCheckboxField,
  SignaturesField,
  NeedSendEmailToManagerCheckboxField,
  CompanyLogoField,
  CompanyColorField,
  StarterDateField
} from "../fields";
import { useCertificate } from "../providers";
import { VerticalSeparator } from './styles';

export function CourseForms({manualUserId, manualCourseId}) {
  return (
    <>
      <UserField manualUserId={manualUserId} />
      <VerticalSeparator />
      <CourseField manualCourseId={manualCourseId} />
      <VerticalSeparator />
      <StarterDateField />
      <VerticalSeparator />
      <EmissionDateField />
      <VerticalSeparator />
      <CompanyLogoField />
      <VerticalSeparator />
      <CompanyColorField />
      <VerticalSeparator />
      <IncludeEmentaCheckboxField />
      <RegenerateCheckboxField />
      <IsEnglishCheckboxField />
      <HideConclusionDateCheckboxField />
      <GenerateEspecialistCheckboxField />
      <NeedSendEmailCheckboxField />
      <NeedSendEmailToManagerCheckboxField />
      <VerticalSeparator />
      <SubmitActionsField />
    </>
  );
}

export function FormationForms() {
  return (
    <>
      <UserField />
      <VerticalSeparator />
      <CourseField />
      <VerticalSeparator />
      <EmissionDateField />
      <VerticalSeparator />
      <IncludeEmentaCheckboxField />
      <RegenerateCheckboxField />
      <HideConclusionDateCheckboxField />
      <NeedSendEmailCheckboxField />
      <NeedSendEmailToManagerCheckboxField />
      <VerticalSeparator />
      <SubmitActionsField />
    </>
  )
}

export function EmentaForms() {
  const {options, updateOptions} = useCertificate();

  useEffect(() => {
    if(!options?.onlyEmenta) {
      updateOptions({optionName: 'onlyEmenta', optionValue: true});
    }
  }, []);

  return (
    <>
      <CourseField />
      <VerticalSeparator />
      <SubmitActionsField />
    </>
  )
}

export function CourseEventForms() {
  return (
    <>
      <UserField />
      <VerticalSeparator />
      <CourseField />
      <VerticalSeparator />
      <EmissionDateField />
      <VerticalSeparator />
      <EventDaysField />
      <VerticalSeparator />
      <RegenerateCheckboxField />
      <IsEnglishCheckboxField />
      <HideConclusionDateCheckboxField />
      <NeedSendEmailCheckboxField />
      <NeedSendEmailToManagerCheckboxField />
      <VerticalSeparator />
      <SubmitActionsField />
    </>
  );
}

export function SpecialistLeanSixSigmaForms({manualUserId}) {
  return (
    <>
      <UserField manualUserId={manualUserId} />
      <VerticalSeparator />
      <EmissionDateField />
      <VerticalSeparator />
      <SpecialistLeanSixSigmaCourseFields />
      <VerticalSeparator />
      <RegenerateCheckboxField />
      <IsEnglishCheckboxField />
      <HideConclusionDateCheckboxField />
      <NeedSendEmailCheckboxField />
      <NeedSendEmailToManagerCheckboxField />
      <VerticalSeparator />
      <SubmitActionsField />
    </>
  );
}

export function InCompanyForms() {
  return (
    <>
      <UserField />
      <VerticalSeparator />
      <CourseField label="Curso In Company"/>
      <VerticalSeparator />
      <ManualCourseNameField />
      <VerticalSeparator />
      <TrainingDaysField />
      <VerticalSeparator />
      <IncludeEmentaCheckboxField />
      <RegenerateCheckboxField />
      <HideConclusionDateCheckboxField />
      <NeedSendEmailCheckboxField />
      <NeedSendEmailToManagerCheckboxField />
      <VerticalSeparator />
      <SubmitActionsField />
    </>
  );
}

export function CustomCertificateForms() {
  const {options, updateOptions} = useCertificate();

  useEffect(() => {
    if(!options?.isCustomCertificate) {
      updateOptions({optionName: 'isCustomCertificate', optionValue: true});
    }

    return () => updateOptions({optionName: 'isCustomCertificate', optionValue: false});
  }, []);

  return (
    <>
      <UserField />
      <VerticalSeparator />
      <CourseField />
      <VerticalSeparator />
      <ManualCourseNameField />
      <VerticalSeparator />
      <TrainingDaysField />
      <VerticalSeparator />
      <WorkloadField />
      <VerticalSeparator />
      <EmissionDateField />
      <VerticalSeparator />
      <ManualEmentaField />
      <VerticalSeparator />
      <SignaturesField />
      <VerticalSeparator />
      <CompanyLogoField />
      <VerticalSeparator />
      <CompanyColorField />
      <VerticalSeparator />
      <IncludeEmentaCheckboxField />
      <RegenerateCheckboxField />
      <IncludeCourseSignaturesCheckboxField />
      <HideConclusionDateCheckboxField />
      <NeedSendEmailCheckboxField />
      <NeedSendEmailToManagerCheckboxField />
      <IsEnglishCheckboxField />
      <VerticalSeparator />
      <SubmitActionsField />
    </>
  );
}